import { Heebo } from "next/font/google";

const engFont = Heebo({ weight: ["100", "400", "700"], subsets: ["latin"] });
const font = {
  className: "fussy-japanese-font",
  style: {
    fontFamily:
      '"IBM Plex Sans JP", "Hiragino Kaku Gothic ProN", "Yu Gothic", Meiryo, sans-serif',
  },
};

export { engFont, font };
